import React from 'react';
import { Tabs, Tab, TextField } from '@material-ui/core';

function TabHeader(props) {
    const { values } = props;
    const changeTab = (event, newValue) => {
        props.setChartVisibleStyle({visibility: 'hidden'});
        props.tabChange(event, newValue);
    }
    return (
        <div className="search-tab-header">
            <Tabs
                value={values.chartParam.sekkeiKubun}
                onChange={changeTab}
                indicatorColor="primary"
                className="search-tabs"
                variant="fullWidth"
                centered={true}
            >
            <Tab label="新　設　橋" value="1" className="search-tab" />
            <Tab label="補　修　橋" value="2" className="search-tab" />
            </Tabs>
            <TextField className="search-display-none" type="hidden" name="sekkeiKubun" value={values.chartParam.sekkeiKubun} />
            <TextField className="search-display-none" type="hidden" name="kozoKubun" value={values.chartParam.shishoKozoKubun} />
        </div>
    )
}

export default TabHeader;
